import React, {useState} from "react"
import { Form, Wrapper, RichText, Padder, Antd } from 'components'
import * as Yup from "yup"
import * as S from "./styles"
import {Layout} from "../../components"
import { contactUs } from '../../api'

const Icon = Antd.Icon

export default (props) => {

  const { translations} = props.pageContext
  const { contactFormInputs, contactText, contactThankyouPage, primary } = translations
  const [ submitted, setSubmitted] = useState(null)
  const [ error ] = useState(null)
  const [ isLoading, setLoading] = useState(null)


  async function handleSubmit(values){
    setLoading(true)
    
    await contactUs(values)

    setLoading(false)
    setSubmitted(true)
  }


  return (
    <Layout {...props}>
      <Wrapper size="large">
      <RichText text={`<p>${contactText}</p>`} />
      <Padder size="big">
        <S.FormWrapper>

        {isLoading && <S.Loading><Icon type="loading" /></S.Loading>}

        { submitted && !error &&
          <S.Thankyou>
            <p>{contactThankyouPage[0]}</p>
            <p>{contactThankyouPage[1]}</p>
            <p>{contactThankyouPage[2]}</p>
            <p>{contactThankyouPage[3]}  <span>godoo</span></p>
          </S.Thankyou>   
        }
        { submitted && error &&
          <S.Thankyou>
          <p>Something is wrong</p>
            <p>try it later</p>
          </S.Thankyou>   
        }

        {!submitted && <Form 
          layout={{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 10  }
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 8 }
            }
          }}
          submitLabel={primary.find(e => e.key === "contactUs").label}
          onSubmit={handleSubmit}
          inputs={contactFormInputs.map(e => ({
              ...e,
              condition: (values) => { 
                if(values.userType === "private"){
                  if(e.name === "companyName") return false
                  if(e.name === "position") return false
                }
                return true
              }
            }))
            .filter(e => e)
          }
          initialValues={{
            userType: 'private'
          }}
          validationSchema={Yup.object().shape({
            firstname: Yup.string().required(contactFormInputs.find(e => e.name === "firstname").required),
            lastname: Yup.string().required(contactFormInputs.find(e => e.name === "lastname").required),
            email: Yup.string().required(contactFormInputs.find(e => e.name === "email").required),
            companyName: Yup.string().when('userType', {
              is: (userType) => userType === "company",
              then: Yup.string().required(contactFormInputs.find(e => e.name === "companyName").required),
            }),
            privacy: Yup.string().required(contactFormInputs.find(e => e.name === "privacy").required)
          })}
        />}
        </S.FormWrapper>
        </Padder>
      </Wrapper>
    </Layout>
  )
}
  